import React, { Component } from 'react';
import { connect } from 'react-redux';

import Spinner from '../../components/UI/Spinner';
import SimpleForm from '../../components/UI/SimpleForm';
import AjaxErrorMessage from '../../components/UI/AjaxErrorMessage';
import Aux from '../../hoc/NoParent';

import { required } from '../../util/formValidationMethods';
import { loadSecurityQuestions, setSecurityQuestionAnswers } from '../../store/actions/index';

class SecurityQuestions extends Component {
    componentDidMount() {
        if(this.props.token) {
            this.props.onLoadQuestions(this.props.token);
        }
    }

    onSubmitForm = (values) => {
        this.props.onUpdateQuestions(values.SecurityQuestionAnswers, this.props.token);
    }

    render() {
        if(this.props.loading) return <Spinner />;

        if(!this.props.questions) return null;

        const formElements = {};
        const initialValues = {
            SecurityQuestionAnswers: []
        };

        for(let i = 0; i < this.props.questions.length; i++) {
            const { usr_security_question_answer_id, usr_security_question_id, usr_answer } = this.props.questions[i];
            const { usr_question } = this.props.questions[i].portal_user_security_question;

            formElements[`SecurityQuestionAnswers[${i}][usr_security_question_answer_id]`] = {
                type: 'hidden'
            };

            formElements[`SecurityQuestionAnswers[${i}][usr_security_question_id]`] = {
                type: 'hidden'
            };

            formElements[`SecurityQuestionAnswers[${i}][usr_answer]`] = {
                type: 'text', 
                placeholder: usr_question, 
                validate: [required]
            };

            initialValues.SecurityQuestionAnswers[i] = {
                usr_security_question_answer_id, 
                usr_security_question_id, 
                usr_answer
            };
            
            //initialValues[`SecurityQuestionAnswers[${i}][usr_security_question_answer_id]`] = usr_security_question_answer_id;
            //initialValues[`SecurityQuestionAnswers[${i}][usr_security_question_id]`] = usr_security_question_id;
            //initialValues[`SecurityQuestionAnswers[${i}][usr_answer]`] = usr_answer;
        }

        return (
            <Aux>
                <SimpleForm 
                    form="SecurityQuestionAnswersForm" 
                    title="Security Questions" 
                    formElements={formElements} 
                    onSubmit={this.onSubmitForm} 
                    initialValues={initialValues} />
                <AjaxErrorMessage error={this.props.error} />
            </Aux>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token, 
        questions: state.account.questions, 
        loading: state.account.loading, 
        error: state.account.error 
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadQuestions: (token) => dispatch(loadSecurityQuestions(token)), 
        onUpdateQuestions: (answers, token) => dispatch(setSecurityQuestionAnswers(answers, token))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SecurityQuestions);